// Dourado vocabulary expansion — FOOD theme (net-new cards).
//
// Extends the `food` blocks in ./vocabulary.js without reusing any headword
// already defined there. Seed upserts on `portuguese`, so every value is unique.
//   [ portuguese, english, emoji, part_of_speech, gender, example_pt, example_en ]

export const VOCAB_FOOD = [
  {
    theme: "food", tier: "A1", rows: [
      ["a maçã", "apple", "🍎", "noun", "f", "Como uma maçã todos os dias.", "I eat an apple every day."],
      ["o tomate", "tomato", "🍅", "noun", "m", "O tomate está maduro.", "The tomato is ripe."],
      ["o frango", "chicken", "🍗", "noun", "m", "Jantamos frango com arroz.", "We're having chicken with rice for dinner."],
      ["o arroz", "rice", "🍚", "noun", "m", "O arroz está pronto.", "The rice is ready."],
      ["a sopa", "soup", "🍲", "noun", "f", "A sopa está muito quente.", "The soup is very hot."],
      ["o sumo", "juice", "🧃", "noun", "m", "Quero um sumo de laranja.", "I want an orange juice."],
      ["a manteiga", "butter", "🧈", "noun", "f", "Põe manteiga no pão.", "Put butter on the bread."],
      ["a laranja", "orange", "🍊", "noun", "f", "A laranja é doce.", "The orange is sweet."],
      ["a batata", "potato", "🥔", "noun", "f", "As batatas estão fritas.", "The potatoes are fried."],
      ["a banana", "banana", "🍌", "noun", "f", "A banana ainda está verde.", "The banana is still green."],
    ],
  },
  {
    theme: "food", tier: "A2", rows: [
      ["a farinha", "flour", "🌾", "noun", "f", "Preciso de farinha para o pão de ló.", "I need flour for the sponge cake."],
      ["a colher de chá", "teaspoon", "🥄", "noun", "f", "Adiciona uma colher de chá de sal.", "Add a teaspoon of salt."],
      ["a tigela", "bowl", "🥣", "noun", "f", "Bate os ovos numa tigela.", "Beat the eggs in a bowl."],
      ["a frigideira", "frying pan", "🍳", "noun", "f", "A frigideira está muito quente.", "The frying pan is very hot."],
      ["a panela", "pot", "🍲", "noun", "f", "Põe a massa na panela.", "Put the pasta in the pot."],
      ["assar", "to roast", "🔥", "verb", "", "Vamos assar legumes no forno.", "We're going to roast vegetables in the oven."],
      ["picar", "to chop", "🔪", "verb", "", "Pica a cebola bem fininha.", "Chop the onion very finely."],
      ["a rodela", "slice (round)", "🍋", "noun", "f", "Corta o limão às rodelas.", "Cut the lemon into slices."],
      ["cru", "raw", "🥩", "adjective", "", "O frango ainda está cru.", "The chicken is still raw."],
      ["maduro", "ripe", "🥑", "adjective", "", "O abacate já está maduro.", "The avocado is ripe now."],
    ],
  },
  {
    theme: "food", tier: "B1", rows: [
      ["a conversa à mesa", "after-meal table talk", "☕", "noun", "f", "A conversa à mesa durou duas horas.", "The after-lunch chat lasted two hours."],
      ["o aperitivo", "appetizer / pre-meal drink", "🫒", "noun", "m", "Tomámos um aperitivo antes de almoçar.", "We had an appetizer before lunch."],
      ["o acompanhamento", "side dish", "🥗", "noun", "m", "O prato leva um acompanhamento de legumes.", "The dish comes with a vegetable side."],
      ["temperar", "to dress / season", "🫗", "verb", "", "Tempera a salada com azeite e vinagre.", "Dress the salad with oil and vinegar."],
      ["enjoativo", "sickly sweet", "🍯", "adjective", "", "Esta sobremesa é demasiado enjoativa.", "This dessert is too sickly sweet."],
      ["o comensal", "dinner guest / diner", "🍽️", "noun", "m", "Éramos oito comensais à mesa.", "There were eight of us at the table."],
      ["escorrer", "to drain", "💧", "verb", "", "Escorre a massa antes de a servir.", "Drain the pasta before serving it."],
      ["em lume brando", "on a low heat", "🔥", "phrase", "", "Cozinha o molho em lume brando.", "Cook the sauce on a low heat."],
      ["a dieta", "diet", "🥦", "noun", "f", "Está de dieta desde janeiro.", "He's been on a diet since January."],
      ["o fogão", "stove / burner", "🍳", "noun", "m", "O fogão tem quatro bicos.", "I have four burners in the kitchen."],
    ],
  },
];
